export default [
  {
    title: 'Tổng quan',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    roleId: 1
  },
  {
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'account_balance_wallet',
    name: 'RechargeHistory',
    roleId: 512
  },
  {
    name: 'CustomerList', 
    title: 'Khách hàng', 
    icon: 'account_box',
    name: 'CustomerList', 
    roleId: 2,
    children: [
      { name: 'CustomerDetail', title: 'Chi tiết khách hàng', component: 'CustomerDetail' }
    ]
  },
  // {
  //   title: 'Tracking',
  //   group: 'apps',
  //   icon: 'gps_fixed',
  //   name: 'Tracking',
  //   roleId: 2048
  // },
  {
    title: 'Mã bill',
    group: 'ma-bill',
    icon: 'inventory',
    name: 'ProductList',
    roleId: 32,
    items: [
      { title: 'Tất cả', name: 'ProductList', component: 'ProductList' },
      { title: 'Nhập kho TQ', name: 'ProductList_TQ', component: 'ProductList_TQ' },
      { title: 'Đã xếp xe', name: 'ProductList_OnWay', component: 'ProductList_OnWay' },
      { title: 'Nhập kho VN', name: 'ProductList_VN', component: 'ProductList_VN' },
      { title: 'Đã xuất kho', name: 'ProductList_Ex', component: 'ProductList_Ex' },
      { title: 'Hàng không tên', name: 'ProductNoneOwnerList', component: 'ProductNoneOwnerList' },
    ]
  },
  {
    title: 'Hàng tồn',
    group: 'hang-ton',
    icon: 'inventory',
    name: 'ProductListInventory',
    roleId: 64,
    items: [
      { title: 'Tồn kho TQ', name: 'ProductList_In_TQ', component: 'ProductList_In_TQ' },
      { title: 'Tồn kho VN', name: 'ProductList_In_VN', component: 'ProductList_In_VN' },
    ]
  },
  {
    title: 'Xếp xe',
    group: 'apps',
    icon: 'local_shipping',
    name: 'OrderList',
    roleId: 64,
    children: [
      { name: 'OrderDetail', title: 'Chi tiết xếp xe', component: 'OrderDetail' }
    ]
  },
  {
    title: 'Xuất kho',
    group: 'apps',
    icon: 'receipt',
    name: 'BillList',
    roleId: 4096,
    children: [
      { name: 'BillDetail', title: 'Chi tiết xuất kho', component: 'BillDetail' }
    ]
  },
  // {
  //   title: 'Thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayOrderList',
  //   roleId: 8
  // },
  // {
  //   title: 'Nhập kho TQ',
  //   group: 'apps',
  //   icon: 'assignment',
  //   name: 'StoreManager',
  //   roleId: 128
  // },
  // {
  //   title: 'Đóng bao TQ',
  //   group: 'apps',
  //   icon: 'archive',
  //   name: 'BigPackage',
  //   roleId: 64
  // },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'speed',
    name: 'Report',
    roleId: 2,
    items: [
      {
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 1024
      }
    ]
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Setting',
    roleId: 256,
    items: [
      {
        title: 'Kho nhận',
        name: 'StorageList',
        component: 'StorageList'
      },
      {
        title: 'Loại hàng',
        name: 'ProductTypeList',
        component: 'ProductTypeList'
      },
      {
        title: 'Phí cân',
        name: 'FeeWeightList',
        component: 'FeeWeightList'
      },
      {
        title: 'Phí khối',
        name: 'FeeVolumeList',
        component: 'FeeVolumeList'
      },
      {
        title: 'Nhân viên',
        name: 'StaffList',
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      }
    ]
  },
  // {
  //   title: 'Lịch sử thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayHistoryList',
  //   roleId: 16
  // }
];
